const EDIT_ORDER = {
  title: 'Edição de pedidos',
  close: 'Fechar',
  confirm: 'Confirmar',
  summaryConfirm: 'Confirmar Edição',
  back: 'Voltar',
  contentTitle: 'Diminua ou zere as quantidades para editar',
  ongoing: 'Substitua ou exclua as quantidades editadas',
  deleted: 'Excluídos',
  deleteButton: 'EXCLUIR',
  deleteButton2: 'Excluir',
  replaceButton: 'SUBSTITUIR',
  replaceButton2: 'Substituir',
  noChanges: 'Nenhuma edição feita até o momento',
  undoButton: 'Desfazer',
  zeroQuantity: 'Zerar a quantidade',
  quantityLabel: 'QTD: ',
  alreadyReviewChanges: 'Você já revisou as edições',
  price: 'R$',
  selectReplacedProduct: 'Selecione um substituto da mesma categoria',
  productSearch: 'Busca de produtos',
  categoryPlaceholder: 'Categorias',
  availability: 'Disponibilidade',
  othersFilter: 'Outros',
  doFilter: 'Filtrar',
  resetFilters: 'Limpar Filtros',
  clearFilterButton: 'Clear Filter Button',
  filterBar: 'Filter Bar',
  replacements: 'Substituídos',
  backButton: 'Voltar',
  confirmButton: 'Confirmar',
  continueButton: 'Continuar',
  CATEGORIES: 'CATEGORIES',
  beers: 'Cervejas',
  productNotFoundSearch: 'Ops, nenhum resultado encontrado para',
  searchForSameCategory:
    'Busque um produto da mesma categoria do produto inicial',
  productNotFound: 'Ops, nenhum resultado encontrado',
  seeMoreProducts: 'Ver mais produtos',
  summaryTitle: 'Resumo da edição',
  deletion: 'Exclusão',
  replace: 'Substituição',
  initialBag: 'Sacola inicial',
  finalBag: 'Sacola final',
  totalLabel: 'TOTAL DOS PRODUTOS',
  printNewOrderOnConfirm: 'Imprimir nova nota ao confirmar',
  defaultRequestError: 'Houve um erro, tente novamente mais tarde',
  editOrderError:
    'Não foi possível editar o pedido, tente novamente mais tarde',
  listItemsQueryError:
    'Não foi possível retornar a lista de produtos disponíveis. Tente novamente mais tarde',
  youWillReplace: 'Você irá substituir:',
  cantDeleteItem: 'Você não pode excluir todos os itens do carrinho',
  editLimit: {
    title: 'Limite de edição excedido ➜',
    deleteMessage: 'Substitua por outro item ou exclua menos itens',
    replacementMessage: '%s a quantidade do produto substituto',
    increase: 'Aumente',
    reduce: 'Diminua',
    minimum: 'Essa edição reduziria o pedido para %val (mínimo: %limit)',
    maximum: 'Essa edição aumentaria o pedido para %val (máximo: %limit)',
  },
  analytics: {
    modalName: 'Order Edit Modal',
    modalNameReplacement: 'Edit Replacement Modal',
    button: 'button',
    returnButton: 'Return Edit Button',
    continueButton: 'Confirm Replacement Button',
    edit: 'Editar',
    resetQuanitity: 'Reset Quantity Button',
    closeModal: 'Close Button',
    goToSummary: 'Go To Summary Button',
    replaceProductButton: 'Replace Product Button',
    deleteProductButton: 'Delete Product Button',
    undoEditButton: 'Undo Edit Button',
    confirmEditButton: 'Confirm Edit Button',
    editSummaryModal: 'Edit Summary Modal',
    replacementProduct: 'Replace Product Button',
    clickReplacementProduct: 'Replacement Product Selection Card',
    filterTypes: {
      search: 'SEARCH',
      categories: 'CATEGORIES',
    },
    macroJourney: 'orders',
    microJourney: 'edit',
  },
  alert: {
    text: 'Avise o cliente antes da edição',
    telephoneButton: 'via Telefone',
    whatsappButton: 'via WhatsApp',
    consumerTelephone: 'Telefone do cliente:',
    whatsappMessage: `Oi! Aqui é a loja %STORE_NAME, parceira do Zé Delivery.\n
Estamos com um problema de estoque de um ou mais itens do seu pedido %ORDER_NUMBER.\n
Você pode nos ajudar decidindo como deseja prosseguir?`,
    error: 'Não foi possível buscar o telefone. Tente novamente mais tarde.',
  },
  onlinePaymentAlert: {
    message:
      'Pedido com pagamento online: não é possível aumentar o valor inicial',
    reverseBill:
      'Pagamento online: a diferença será estornada automaticamente para o cliente após a entrega.',
    maximum: '(máximo: %val)',
  },
}

export default EDIT_ORDER
